import { useEffect } from 'react';
import { SessionStorageManager } from '@atlas/core';
import { POPUP_SIGN_UP_DELAY_STORAGE_KEYS } from 'common/constants';

const { TIMEOUT_ID } = POPUP_SIGN_UP_DELAY_STORAGE_KEYS;

export const useHidePopupSignUpDelay = () => {
  useEffect(() => {
    const timeoutId = SessionStorageManager.getItem(TIMEOUT_ID);
    if (timeoutId) {
      clearTimeout(timeoutId);
      SessionStorageManager.removeItem(TIMEOUT_ID);
    }
  }, []);
};
